import React, { useEffect, useRef, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import errorToast from '../../components/toasts/errorToast';
import { viewTranslationsJobAction } from '../../redux/actions/translationAction';
import { IoArrowBack } from 'react-icons/io5';
import { Spinner } from 'react-bootstrap';
import OkapiDocumentSegmentsEditor from '../../components/editors/okapi-segments-editor';
import { OKAPI_BASE_URL } from '../../redux/config';
import { useAuth } from '../../context/AuthContext';



export const OkapiDocumentSegments = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { user } = useAuth();
    const { id } = useParams()
    const documentDataRef = useRef(null)
    const [isLoading, setLoading] = useState(false);
    const [sourceFileUrl, setSourceFileUrl] = useState(null);
    const [targetFileUrl, setTargetFileUrl] = useState(null);
    const [documentData, setDocumentData] = useState(null);

    const fileType = documentData?.file_name?.split('.').pop();

    console.log('fileType :>> ', fileType);
    const onError = (data) => {
        errorToast(data?.data?.message)
    }

    function toGsUrl(url) {
        const prefix = "https://storage.googleapis.com/";
        const gsPrefix = "gs://";

        if (url.startsWith(prefix)) {
            return url.replace(prefix, gsPrefix);
        }
        return url; // return unchanged if it doesn't match
    }

    useEffect(() => {
        if (id) {
            setLoading(true)
            dispatch(viewTranslationsJobAction({ id }, onSuccess, onError));
        }
    }, [id]);

    const onSuccess = (data) => {
        const documentData = data?.data?.data;
        setDocumentData(documentData);
        documentDataRef.current = documentData;
        setSourceFileUrl(documentData?.source_gsurl);
        const { is_post_edit, is_glossary, post_edit_url, glossary_url, translated_url } = documentData || {};
        const fileUrl = is_post_edit ? post_edit_url : is_glossary ? glossary_url : translated_url;
        const targetGcsUrl = toGsUrl(fileUrl)
        setTargetFileUrl(targetGcsUrl)
        setLoading(false);
    };



    return (
        <div className='d-flex vh-100 overflow-auto flex-column' style={{ backgroundColor: '#E9EEF7' }}>
            <div className="w-100 d-flex align-items-center header border-bottom position-sticky top-0 bg-white py-2 z-3">
                <span className="px-3 fs_16 cursor_pointer pb-1" onClick={() => navigate(-1)}><IoArrowBack /></span>
                <h2 className="fs_20 fw_400 fn_Roboto text-start pt-1"> Post Editing</h2>
            </div>

            {
                (isLoading && !fileType) &&
                <div className="d-flex justify-content-center align-items-center m-2 bg-white rounded-4" style={{ height: "100%" }}>
                    <Spinner animation="border" variant="primary" />
                </div>
            }
            {targetFileUrl && documentDataRef.current?.source_gsurl &&
                <OkapiDocumentSegmentsEditor
                    apiUrl={OKAPI_BASE_URL}
                    docFileName={documentDataRef.current?.file_name}
                    docGcsUrl={documentDataRef.current?.source_gsurl}
                    docId={id}
                    docTrlGcsUrl={targetFileUrl}
                    documentData={documentDataRef.current}
                    srcLang={documentDataRef.current?.source_lang}
                    trgLang={documentDataRef.current?.target_lang}
                    userId={user?.id}
                />
            }
        </div >
    )
}
